/**
 * Thin wrapper around window.location.assign to make navigation mockable in tests.
 * Using a module-level function allows vi.mock to intercept calls without
 * needing to modify the non-configurable window.location.assign in jsdom.
 */
export function navigateTo(path: string): void {
  window.location.assign(path);
}
